import { Pagination } from "@shopify/polaris";
import { useState } from "react";
import { OrderPaginationTypes } from "../../store/types/types";

export default function GeneralPagination({
  currentPage,
  totalPages,
  onPageChange,
  total,
  itemName = "orders",
}: OrderPaginationTypes) {
  const params = new URLSearchParams(window.location.search);
  const [recordsLimit] = useState(params.get("limit") || "50");
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(String(currentPage - 1), recordsLimit || "50");
    }
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(String(currentPage + 1), recordsLimit || "50");
    }
  };
  const start = (currentPage - 1) * Number(recordsLimit) + 1;
  const end = Math.min(currentPage * Number(recordsLimit), Number(total));
  return (
    <div
      style={{
        background: "none",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        borderRadius: "10px",
        overflow: "hidden",
      }}
    >
      <Pagination
        nextTooltip="Next"
        onPrevious={handlePrevious}
        onNext={handleNext}
        hasPrevious={currentPage > 1}
        type="page"
        hasNext={currentPage < totalPages}
        label={`${start} - ${end} of ${total} ${itemName}`}
      />
    </div>
  );
}
